import SliderUI, {
  type ISlider,
} from '@axo/shared/ui/input/lib/Slider/SliderUI';
import { Controller, useFormContext } from 'react-hook-form';
import { IControlledField, IFormFields } from '../UI.types';
import { useReloadValue } from '../../hooks';

interface Props<Fields> extends ISlider, IControlledField<Fields> {}

const SliderFieldUI = <Fields extends IFormFields>({
  name,
  rules,
  ...sliderProps
}: Props<Fields>) => {
  const { control } = useFormContext();
  useReloadValue(name);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value } }) => (
        <SliderUI
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          {...sliderProps}
        />
      )}
    />
  );
};

export default SliderFieldUI;
